import React from 'react';
import { useLocation } from 'react-router-dom';
import { STANDALONE_EDITOR_PREFIX, SETTINGS_PREFIX } from '../constants/navigation';

function AdminFooter() {
	const location = useLocation();
	if (location.pathname.startsWith(STANDALONE_EDITOR_PREFIX)) return null;
	if (location.pathname.startsWith(SETTINGS_PREFIX)) return null;

	return (
		<footer className='tw:flex tw:items-center tw:justify-center tw:gap-0 tw:border-t tw:border-border tw:text-ink-3 tw:text-xs'>
			<span>Desarrollado por</span>
			<img src='/images/logoFooter.svg' alt='Gotasoft' className='tw:h-10 tw:w-auto tw:opacity-70' />
			<span className='tw:text-ink-4'>·</span>
			<span>© Todos los derechos reservados 2025</span>
		</footer>
	);
}
export default AdminFooter;
